import type { ViewProps } from 'react-native';
import React from 'react';

// Provides a stub for react-native-google-cast on web.
export function CastButton(_props: ViewProps): JSX.Element {
  return <></>;
}
